export const Notfound = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-4">
      <h1 className="text-3xl font-bold">404 - Page Not Found</h1>
    </div>
  );
};
